import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { ComponentType } from 'react';

import { queryClient } from '@/lib/query/queryClient';

export function withQuery<T extends object>(WrappedComponent: ComponentType<T>) {
  return function WithQueryComponent(props: T) {
    return (
      <QueryClientProvider client={queryClient}>
        <WrappedComponent {...props} />
        {import.meta.env.DEV && <ReactQueryDevtools />}
      </QueryClientProvider>
    );
  };
}
